import { render, staticRenderFns } from "./EventStat.vue?vue&type=template&id=4e180648&"
import script from "./EventStat.vue?vue&type=script&lang=js&"
export * from "./EventStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports